import { render, staticRenderFns } from "./VideoElementSettings.vue?vue&type=template&id=64807859&scoped=true&"
import script from "./VideoElementSettings.vue?vue&type=script&lang=ts&"
export * from "./VideoElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64807859",
  null
  
)

export default component.exports